import React from "react";

const EditIcon = () => {
  return (
    <>
      <svg width="15.113" height="15.265" viewBox="0 0 15.113 15.265">
        <path
          id="Icon_feather-edit-2"
          data-name="Icon feather-edit-2"
          d="M6.437,3.847A2.013,2.013,0,1,0,3.59,6.694L13.2,16.3l3.915,1.068-1.068-3.915Z"
          transform="translate(17.87 -2.348) rotate(90)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
      </svg>
    </>
  );
};

export default EditIcon;
